import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
var _excluded = ["tag", "itemTag", "iconPlacement", "disabled", "size", "mode", "disableCursor", "theme", "enableKeyboardNavigation", "activateFirstItem", "className", "wrapItemsWithLi", "returnFocusOnUnmount"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { MenuProvider } from './parts/menu-context.js';
import styles from './index.p.module.css.js';
import { useMenuKeyboardNavigation } from './parts/use-menu-keyboard-navigation.js';

var Menu = function Menu(_ref) {
  var _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'ul' : _ref$tag,
      itemTag = _ref.itemTag,
      iconPlacement = _ref.iconPlacement,
      disabled = _ref.disabled,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'm' : _ref$size,
      mode = _ref.mode,
      _ref$disableCursor = _ref.disableCursor,
      disableCursor = _ref$disableCursor === void 0 ? false : _ref$disableCursor,
      theme = _ref.theme,
      _ref$enableKeyboardNa = _ref.enableKeyboardNavigation,
      enableKeyboardNavigation = _ref$enableKeyboardNa === void 0 ? false : _ref$enableKeyboardNa,
      _ref$activateFirstIte = _ref.activateFirstItem,
      activateFirstItem = _ref$activateFirstIte === void 0 ? false : _ref$activateFirstIte,
      className = _ref.className,
      wrapItemsWithLi = _ref.wrapItemsWithLi,
      _ref$returnFocusOnUnm = _ref.returnFocusOnUnmount,
      returnFocusOnUnmount = _ref$returnFocusOnUnm === void 0 ? false : _ref$returnFocusOnUnm,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var Tag = tag;

  var _useMenuKeyboardNavig = useMenuKeyboardNavigation({
    enableKeyboardNavigation: enableKeyboardNavigation,
    activateFirstItem: activateFirstItem,
    returnFocusOnUnmount: returnFocusOnUnmount
  }),
      activeItemRef = _useMenuKeyboardNavig.activeItemRef,
      registerItem = _useMenuKeyboardNavig.registerItem,
      unregisterItem = _useMenuKeyboardNavig.unregisterItem,
      isKeyboardNavigating = _useMenuKeyboardNavig.isKeyboardNavigating;

  return /*#__PURE__*/React.createElement(MenuProvider, {
    itemTag: itemTag,
    iconPlacement: iconPlacement,
    disabled: disabled,
    size: size,
    disableCursor: disableCursor || isKeyboardNavigating,
    mode: mode,
    theme: theme,
    registerItem: registerItem,
    unregisterItem: unregisterItem,
    activeItemRef: activeItemRef.current,
    isKeyboardNavigating: isKeyboardNavigating,
    wrapWithLi: wrapItemsWithLi !== null && wrapItemsWithLi !== void 0 ? wrapItemsWithLi : tag === 'ul'
  }, /*#__PURE__*/React.createElement(Tag, _objectSpread({
    className: cn(!enableKeyboardNavigation && styles.keyboardNavigationDisabled, className)
  }, restProps)));
};

Menu.propTypes = {
  size: PropTypes.oneOf(['l', 'm', 's']),
  mode: PropTypes.oneOf(['clear', 'classic', 'rock']),
  theme: PropTypes.oneOf(['light', 'dark']),
  disableCursor: PropTypes.bool,
  disabled: PropTypes.bool,
  iconPlacement: PropTypes.oneOf(['left', 'right']),
  itemTag: PropTypes.elementType,
  tag: PropTypes.elementType
};
export { Menu, Menu as default };
